
module.exports = { 
menu : { 
    home:"Home",
    product: "Product",
    scheme: "Scheme",
    hardware: "Hardware",
    case: "Case",
    us: 'Us',
    help: 'Help',
    consult: 'Consult',
    wisdom:"Wisdom sees the future"
  }, 
  content:{ 
    main:"this is content" 
  } 
}
 


// WEBPACK FOOTER //
// ./src/assets/lang/en.js